import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as tmxActions from '../Actions/tmxActions';
import TmxList from "../Components/Tmx/TmxList";
import { tmxService } from "../Services/TmxService.js";
 import { Link } from 'react-router-dom';

class TmxListContainer extends Component {
	constructor(props){
		super(props);
		this.cercaClient = this.cercaClient.bind(this);
	}
	
	componentDidMount() {
		tmxService.listTmx(this.props.user.access_token)
					.then(response => {return this.props.actions.fetchTmxRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
	}
	
	cercaClient(acum, value){
		if(value){
			if(value.user!==null){
				acum += value.name;
			}
		}
		return acum;
	}
	
	render() {
//		console.log("[TmxListContainer.render()] this.props.customerRecords: "+JSON.stringify(this.props.tmxRecords));
		let tmxF = ((typeof this.props.search !== 'undefined') && (this.props.search.length > 0)) ? (this.props.tmxRecords.filter(tmx => {return (tmx.description.toUpperCase().includes(this.props.search.toUpperCase()) ||
																									tmx.languagePair.code.toUpperCase().includes(this.props.search.toUpperCase()) ||
																									tmx.customers.reduce(this.cercaClient,"").toUpperCase().includes(this.props.search.toUpperCase()) )}) ) : (this.props.tmxRecords);
	    //let uploadTmx=
		
		return (<div className="content">
					<TmxList	tmxs={tmxF}
							tmxActions={this.tmxActions}
							accessToken={this.props.user.access_token}/>
					<Link style={{textDecoration: 'none'}} to={`/tmxUploadForm`}>UPLOAD TMX</Link>
				</div>);
	}
}

function mapStateToProps(state, ownProps) {  
//	console.log('mapStateToProps [TmxListContainer]: ' + JSON.stringify(state));
	return {tmxRecords: state.tmxs, user: state.user, search: state.search.searchString}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(tmxActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(TmxListContainer);  